import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import TextButton from '../TextButton';
import { useTranslation } from '../../src/i18n';
import { TP } from '../../constants/consts';
import { border } from '../../constants/styleConstants';

const useStyles = makeStyles(theme => ({
  addAnotherButton: {
    marginTop: theme.spacing(2),
    '&:focus': {
      outline: border.lightGrey,
    },
    '& .MuiButton-label': {
      [theme.breakpoints.down('sm')]: {
        fontSize: '0',
      },
    },
  },
}));

const AddAnotherFieldButton = ({ onClick, disabled, addButtonText, tabIndex }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <TextButton
      onClick={onClick}
      startIcon={<AddCircleIcon color="secondary" />}
      disabled={disabled}
      className={classes.addAnotherButton}
      tabIndex={tabIndex}
    >
      {t(addButtonText)}
    </TextButton>
  );
};

AddAnotherFieldButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  addButtonText: PropTypes.string,
  tabIndex: PropTypes.number,
};

AddAnotherFieldButton.defaultProps = {
  addButtonText: `${TP}.FN_ADD_ANOTHER_FIELD`,
  disabled: false,
  tabIndex: 0,
};

export default memo(AddAnotherFieldButton);
